import {formatoFechaExportacion} from "../../Utilidades/formatoFechaExportacion";

export const adaptador_pedidos_exportacion = (reservas) => {


    let arr = []
    for (let i = 0; i < reservas.length; i++) {
        let reserva = reservas[i]
        delete reserva.productos
        delete reserva.guardar
        let obj = {
            ...reserva,
            fecha: formatoFechaExportacion(reserva.fecha),
            fechaCumple: formatoFechaExportacion(reserva.fechaCumple),

        }
        arr.push(obj)
    }

    return arr

}